import { useEffect } from "react";
import { Switch, Route, useHistory, useParams } from "react-router-dom";
import { X } from "lucide-react";
import {
  MERCHANT_EXIT_PATH,
  TOTAL_STEPS,
  getMerchantStepPath,
} from "./constants";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";
import Step5 from "./steps/Step5";

const ProgressBar = ({ step }: { step: number }) => (
  <div className="w-full h-1 bg-gray-100">
    <div
      className="h-1 bg-skin-primary transition-all duration-300"
      style={{ width: `${(step / TOTAL_STEPS) * 100}%` }}
    />
  </div>
);

const Header = ({ onClose, step }: { onClose: () => void; step: number }) => (
  <div className="border-b border-gray-100 bg-white shrink-0">
    <div className="flex items-center justify-between px-6 py-4 md:px-12">
      <span className="text-sm font-semibold text-gray-900">
        Merchant Processing Application
      </span>
      <button
        type="button"
        onClick={onClose}
        className="rounded-full p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
        aria-label="Close"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
    <ProgressBar step={step} />
  </div>
);

const MerchantProcessingOnboarding = () => {
  const history = useHistory();
  const { step } = useParams<{ step: string }>();
  const stepNumber = parseInt(step, 10);

  const handleClose = () => {
    history.push(MERCHANT_EXIT_PATH);
  };

  useEffect(() => {
    if (isNaN(stepNumber) || stepNumber < 1 || stepNumber > TOTAL_STEPS) {
      history.replace(getMerchantStepPath(1));
    }
  }, [stepNumber, history]);

  return (
    <div className="fixed inset-0 z-50 bg-gray-50 flex flex-col">
      <Header onClose={handleClose} step={stepNumber} />
      <div className="flex-1 overflow-hidden flex flex-col">
        <Switch>
          <Route path="/invoices/settings/merchant/1" component={Step1} />
          <Route path="/invoices/settings/merchant/2" component={Step2} />
          <Route path="/invoices/settings/merchant/3" component={Step3} />
          <Route path="/invoices/settings/merchant/4" component={Step4} />
          <Route path="/invoices/settings/merchant/5" component={Step5} />
        </Switch>
      </div>
    </div>
  );
};

export default MerchantProcessingOnboarding;
